import { getClienteLogoUrl } from "@/lib/api";
import { nombreVisible } from "@/lib/clienteNombre";
import { UserAvatar } from "@/components/UserAvatar";
import { cn } from "@/lib/utils";

/** Logo del cliente; si no tiene, un avatar generado a partir de su nombre (cuadrado redondeado para distinguirlo de las personas). */
export function ClienteLogo({ cliente, size = 40, className = "" }) {
  const id = cliente?.id;
  const nombre = nombreVisible(cliente);
  const tieneLogo = cliente?.tiene_logo || cliente?.logo_version;
  return (
    <div
      className={cn("shrink-0 overflow-hidden rounded-xl bg-white border border-black/5 flex items-center justify-center", className)}
      style={{ width: size, height: size }}
    >
      {tieneLogo && id ? (
        <img src={getClienteLogoUrl(id, cliente.logo_version)} alt="" className="w-full h-full object-cover" loading="lazy" />
      ) : (
        <UserAvatar name={nombre} variant="marble" size={size} square />
      )}
    </div>
  );
}
